import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { multilineEllipsis } from "./base.styles";
import CustomDataGridPaginationView from "./HXDataGridCustomPaginationView";
import { FlexColumn, HorizontalDivider } from "./common.styles";
import { fontSizes } from "healthex-common/sizes";
const DataGridEl = styled(DataGrid) `
    background-color: ${colors.white_main};

    & .MuiDataGrid-cell,
    & .MuiDataGrid-columnHeader {
        font-size: ${fontSizes.SMALL};
    }

    & :not(.singleLineEllipis) > .MuiDataGrid-cellContent {
        ${multilineEllipsis(2)}
    }

    & .singleLineEllipis > .MuiDataGrid-cellContent {
        text-overflow: ellipsis;
        overflow: hidden;
    }

    & .MuiDataGrid-columnHeaderTitle {
        ${multilineEllipsis(2)}
        line-height: normal;
    }

    --DataGrid-overlayHeight: 72px; // "No rows" message height
`;
export const HXDataGridCellContent = styled.div.attrs({ className: "MuiDataGrid-cellContent" }) ``;
export const HXDataGrid = (props) => {
    const { sx, columns, paginationSelectedLabel, toolbar, showPagination } = props;
    const shouldShowPagination = showPagination === true || showPagination === undefined;
    const resolvedColumns = columns.map((column) => {
        return {
            ...column,
            sortingOrder: ["asc", "desc"],
        };
    });
    const resolvedSx = {
        ...sx,
        ...{
            [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
                outline: "none",
            },
            [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]: {
                outline: "none",
            },
        },
    };
    const resolvedProps = {
        disableEval: true,
        disableColumnMenu: true,
        autoHeight: true,
        rowHeight: 72,
        pagination: true,
        paginationMode: "server",
        keepNonExistentRowsSelected: true,
        ...props,
        columns: resolvedColumns,
        sx: resolvedSx,
        components: {
            Toolbar: () => !!toolbar || shouldShowPagination ? (_jsxs(FlexColumn, { children: [toolbar && toolbar, shouldShowPagination && (_jsxs(_Fragment, { children: [_jsx(CustomDataGridPaginationView, { selectedLabel: paginationSelectedLabel }, props.key), _jsx(HorizontalDivider, {})] }))] })) : null,
            Footer: () => shouldShowPagination ? _jsx(CustomDataGridPaginationView, { selectedLabel: paginationSelectedLabel }, props.key) : null,
        },
    };
    return _jsx(DataGridEl, { ...resolvedProps }, props.key);
};
